import React, { Component } from "react";
import { postRequest, withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import Form from "./Form";
import { toast } from "../../../utils/helpers";
import Modal from "../../general/Modal";

class CreateSolicitud extends Component {
    state = {
        vehiculos: [],
        empleados: [],
        saving: false,
        showDelete: false,
    };
    componentDidMount() {
        this.getTable("vehiculos");
        this.getTable("empleados", "?estado=activos");
    }
    updateSolicitud = async (event, id) => {
        event.preventDefault();

        this.setState({
            saving: true
        });

        const data = new FormData(event.target);
        const response = await postRequest(apiUrl(`solicitudes/${id}`), data);

        if (response.success) {
            if (this.props.getSolicitudes) {
                this.props.getSolicitudes();
            }
            this.props.toggle();
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({
            saving: false
        });
    };
    getTable = async (url = null, params = "") => {
        const table = await this.props.request(url + params);

        if (table.data && table.data.length > 0) {
            this.setState({
                [url]: table.data
            });
        }
    };
    toggleDeleteModal = (event) => {
        event.preventDefault();

        this.setState({
            showDelete: !this.state.showDelete,
        })
    };
    deleteSolicitud = async () => {
        const url = `solicitudes/${this.props.solicitud.id}`;

        const response = await postRequest(apiUrl(url), {}, 'delete');

        if (response.success) {
            if (this.props.getSolicitudes) {
                this.props.getSolicitudes();
            }
            this.toggleDeleteModal();
            this.props.toggle();
            toast("Tarea borrada.");
            return;
        } else {
            toast(response.data, "error");
        }
    };
    render() {
        const { empleado, solicitud } = this.props;
        const { vehiculos, empleados } = this.state;
        return <>
            <form
                id='solicitudesform'
                method='post'
                onSubmit={e => this.updateSolicitud(e, solicitud.id)}>
                <input type='hidden' name='_method' value='PATCH' />
                <div className='popup__header'>Editar Tarea</div>
                <Form
                    empleado={empleado}
                    vehiculos={vehiculos}
                    empleados={empleados}
                    solicitud={solicitud}
                />
                <div className='popup__footer'>
                    <button
                        type='button'
                        className='btn float-left'
                        onClick={e => this.toggleDeleteModal(e)}>
                        <i className='fas fa-trash-alt'></i>
                    </button>
                    <button
                        type='button'
                        onClick={this.props.toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {this.state.saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    )}
                </div>
            </form>

            <Modal
                title="Borrar Tarea"
                show={this.state.showDelete}
                callback={() => this.deleteSolicitud()}
                acceptText="Borrar"
                toggle={this.toggleDeleteModal}
            >
                ¿Estás seguro de que deseas borrar esta tarea?
            </Modal>
        </>;
    }
}

export default withRequest(CreateSolicitud);
